import { render } from "./ContactSettings.vue?vue&type=template&id=32be3494"
import script from "./ContactSettings.vue?vue&type=script&lang=js"
export * from "./ContactSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__